import Funnel from "../../services/funnel-service.js";
import Utils from "../../services/utils-service.js";
import Vue from 'vue';

const template = `
<span class="tooltip-container">
    <button 
        class="has-tooltip" 
        @click.prevent="tooltipClick($event)"
        v-tooltip="{
            content: computedHelpText,
            show: showTooltip,
            trigger: 'manual',
            placement: tooltipPlacement
        }"
        v-close-tooltip-click-outside="clickedOutside"
        :aria-expanded="showTooltip"
        tabindex="0"
        :ref="this.element.uid+'_tooltip_button'"
        aria-atomic="true"
        @keydown="handleKeydown($event,element)"
        :data-toggletip-content="computedHelpText"
        :aria-label="'tooltip button for: '+ computedTooltipLabel"
    >
    </button>
    <span role="status" class="sr-only">
        <span v-if="showTooltip" class="toggletip-bubble">{{computedHelpText}}</span>
    </span>
  </span>
`;

export default {
    name: 'b-tooltip',
    template,
    props: ['element'],
    data: function () {
        return {
            showTooltip:false
        }
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        tooltipPlacement: function(){
            if (this.element.helpText.placement && !this.fs.isMobile()) {
                return this.element.helpText.placement
            }else{
                return "bottom"
            }
        },
        computedHelpText: function () {
           return this.element.helpText.content
        },
        computedTooltipLabel: function(){  
            if (this.element.label) {
                return this.element.label
            }
            if (this.element.title) {
                return this.element.title
            }
            if (this.element.description) {
                return this.element.description
            }
        }
    },
    methods: {
        clickedOutside: function(){
            this.showTooltip = false
        },
        tooltipClick(e){
            this.showTooltip = !this.showTooltip; 
            console.log(e.target)
        },
        handleKeydown: function(event,input){
            if (event.target === this.$refs[input.uid+"_tooltip_button"])  {
                if (event.key === ' ' || event.key === 'Enter') {
                    event.preventDefault()
                    this.$refs[input.uid+"_tooltip_button"].click();
                   
                }
            }
        }
    }
};

Vue.directive('close-tooltip-click-outside', {
    bind: function (el, binding, vnode) {
        
      el.clickOutsideEvent = function (event) {
        if (!(el.parentNode.parentNode == event.target.parentNode || el.parentNode.parentNode.contains(event.target.parentNode))) {
            vnode.context[binding.expression](event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});